var render = function render(){var _vm=this,_c=_vm._self._c;return _c('marker',{attrs:{"viewBox":`0 0 ${_vm.radius*2} ${_vm.radius*2}`,"refX":_vm.radius,"refY":_vm.radius,"markerWidth":_vm.radius,"markerHeight":_vm.radius,"orient":"auto"}},[_c('circle',{style:(`fill: ${_vm.stroke}`),attrs:{"cx":_vm.radius,"cy":_vm.radius,"r":_vm.radius}})])
}
var staticRenderFns = []

export { render, staticRenderFns }